import {Component} from '@angular/core';
import {GlobalMessageService} from '@spartacus/core';
import {GlobalMessageComponent} from '@spartacus/storefront';
import {trigger, state, style, transition, animate} from '@angular/animations';

@Component({
  selector: 'dcp-global-message',
  templateUrl: './global-message.component.html',
  animations: [
    trigger('fadeInOut', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in'),
      ]),
      transition(':leave', [
        animate('400ms ease-out', style({opacity: 0})),
      ]),
    ]),
  ],
})
export class DcpGlobalMessageComponent extends GlobalMessageComponent {
  constructor(
    protected globalMessageService: GlobalMessageService
  ) {
    super(globalMessageService)
  }
}
